import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useGetAuthor() {
  const project = useCurrentProject();
  const params = useParams();

  const authorId = Number(params.authorId);

  return useQuery({
    queryKey: [project, 'author', authorId],
    queryFn: () => Api.authors.getAuthor(project, authorId),
    enabled: !!authorId,
  });
}

export function useGetAuthorBooks() {
  const project = useCurrentProject();
  const params = useParams();

  const authorId = Number(params.authorId);

  return useQuery({
    queryKey: [project, 'author-books', authorId],
    initialData: {
      books: [],
      count: 0,
    },
    queryFn: () =>
      Api.books.getBooks(project, { limit: 100, offset: 0, authorId }),
    enabled: !!authorId,
  });
}
